export default __webpack_public_path__ + "static/zitat-tellerand-b97f3ee4c5af9ff0778585e625288657.svg";